import Menu from "./Menu/Menu";

const SideBar = () => {
  return (
    <div className="sidebar">
      <Menu />
    </div>
  );
};

export default SideBar;
